const isEnterFromSystem = ({ keyCode, which }) => (keyCode && keyCode === 229) || (which && which === 229);

export const KEY = {
  isEsc: (e) =>
    e.key
      ? e.key === 'Escape' || e.key === 'Esc' /* IE/Edge */
      : (e.charCode && e.charCode === 27) || (e.keyCode && e.keyCode === 27),
  isEnter: ({ key, charCode, keyCode, which }) =>
    key
      ? key === 'Enter' && !isEnterFromSystem({ keyCode, which })
      : (charCode && charCode === 13) || (keyCode && keyCode === 13),
  isSpace: (e) => (e.key ? e.key === ' ' : (e.charCode && e.charCode === 32) || (e.keyCode && e.keyCode === 32)),
};

/**
 * Return true if the SPACE or the ENTER key is pressed
 * @param {Event} e
 */
export const isActionKey = (e) => KEY.isSpace(e) || KEY.isEnter(e);

/**
 * Return true if the ESCAPE key is pressed
 * @param {Event} e
 */
export const isEscape = (e) => KEY.isEsc(e);
